import {
  DataGridPro,
  GridToolbar,
  GridLogicOperator,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridNoRowsOverlay,
} from "@mui/x-data-grid-pro";
import Alert from "@material-ui/lab/Alert";
import { Grid, Box } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import "./gridCustomToolbar/GridCustomToolbar.scss";

export const DataGridCystellarTable = (props) => {
  const { t } = useTranslation();

  if (!props.columns) throw new Error("Columns field must be provided to data grid table");
  if (!props.rows) throw new Error("Rows field must be provided to data grid table");

  const {
    customToolbarWidgets,
    customToolbarCompMsg,
    customNoRowsMsg,
    customToolbarComp,
    customExtraFooterInfo,
  } = props;

  // TODO: use the component from gridCustomToolbar folder instead
  const customGridToolbar = () => {
    return (
      <Box p={1}>
        <GridToolbarContainer>
          <Grid container item xs>
            <GridToolbarColumnsButton />
            <GridToolbarFilterButton />
            {customToolbarWidgets}
          </Grid>

          {customToolbarCompMsg !== undefined && (
            <Grid>
              <Alert background="white" severity="info">
                {customToolbarCompMsg}
              </Alert>
            </Grid>
          )}
        </GridToolbarContainer>
      </Box>
    );
  };

  const getNoRowsOverlay = () => (
    <Box display="flex" height="100%" alignItems="center" justifyContent="center">
      {customNoRowsMsg}
    </Box>
  );

  const customFooter = () => (
    <Box display="flex" alignItems="center" justifyContent="end" mb={2} mr={2}>
      <Box mr={2}>{customExtraFooterInfo}</Box>
      <div>Total Rows: {props.rows.length}</div>
    </Box>
  );

  const tableData = {
    pagination: true,
    pageSizeOptions: [25, 50, 100],
    disableDensitySelector: true,
    disableColumnPinning: true,
    hideFooterSelectedRowCount: true,
    autoHeight: true,
    density: "compact",

    localeText: {
      toolbarColumns: t("table.columns"),
      toolbarFilters: t("table.filters"),
    },

    componentsProps: {
      toolbar: {
        csvOptions: { disableToolbarButton: true },
        printOptions: { disableToolbarButton: true },
        showQuickFilter: false,
      },
      filterPanel: {
        filterFormProps: {
          logicOperators: [GridLogicOperator.And],
        },
      },
    },
    ...props,
  };

  return (
    <DataGridPro
      {...tableData}
      sx={{
        ".MuiDataGrid-cell:focus": {
          outline: "none",
        },
        "& .MuiDataGrid-row:hover": {
          cursor: "pointer",
        },
        // "& .MuiDataGrid-virtualScroller": {
        //   overflow: "scroll"
        // }
      }}
      slots={{
        toolbar: customToolbarComp ? customGridToolbar : GridToolbar,
        noRowsOverlay: customNoRowsMsg ? getNoRowsOverlay : GridNoRowsOverlay,
        // TODO: this is no longer needed for now
        // footer: customExtraFooterInfo ? customFooter : GridFooter,
      }}
    />
  );
};
